import React from 'react';
import { observer } from 'mobx-react-lite';
import { useIntl } from 'react-intl';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import CreditCardShape from '../definitions/CreditCardShape';
import FooterDefaultIntlFormatValues from '../definitions/FooterDefaultIntlFormatValues';
import getInterestAndMinimumIncomeColumns from '../functions/getInterestAndMinimumIncomeColumns';
import CardFooter from './CardFooter';


function CardFooterSecured({ cardInfo, ...otherProps }) {
    const intl = useIntl();

    const columns = [
        cardInfo.signUpBonusPoints
            ? intl.formatMessage(COMMON_MESSAGES.cardFooterSignUpBonus, {
                ...DefaultIntlFormatValues,
                ...FooterDefaultIntlFormatValues,
                ...cardInfo,
            })
            : null,

        cardInfo.anniversaryBonus?.points
            ? intl.formatMessage(COMMON_MESSAGES.cardFooterAnniversaryBonus, {
                ...DefaultIntlFormatValues,
                ...FooterDefaultIntlFormatValues,
                anniversaryBonusPoints: cardInfo.anniversaryBonus.points,
                anniversaryBonusValue: cardInfo.anniversaryBonus.value,
            })
            : null,

        ...getInterestAndMinimumIncomeColumns({
            purchaseInterest: cardInfo.purchaseInterest,
            cashAdvanceInterest: cardInfo.cashAdvanceInterest,
            balanceTransferInterest: cardInfo.balanceTransferInterest,

            minimumIncome: cardInfo.minimumIncome,
            minimumCreditScore: 'any',  // value for select comparison in message definition
            intl,
        }),
    ];

    return (
        <CardFooter
            columns={columns}
            {...otherProps}
        />
    );
}

CardFooterSecured.propTypes = {
    cardInfo: CreditCardShape.isRequired,
};


export default observer(CardFooterSecured);
